import React, { useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { H2, IconSpinner, NamedLink } from '../index';
import css from './OrderPanelHeadingSection.module.css';
import { createSlug, stringify } from '../../util/urlHelpers';

const createListingLink = (
  listingId,
  label,
  listingDeleted,
  searchParams = {},
  className = '',
  customLabel = ''
) => {
  if (!listingDeleted) {
    const params = { id: listingId, slug: createSlug(label) };
    const to = { search: stringify(searchParams) };
    return (
      <NamedLink className={className} name="ListingPage" params={params} to={to}>
        {customLabel ? customLabel : label}
      </NamedLink>
    );
  } else {
    return <FormattedMessage id="TransactionPanel.deletedListingOrderTitle" />;
  }
};

const OrderPanelHeadingSection = ({
  isProviderRole,
  listing,
  shop,
  brand,
  transaction,
  onGetShop,
  onGetBrand,
  getHeadingInfoInProgress,
  rootClassName,
}) => {
  if ((!shop && !listing) || !transaction) return null;

  const intl = useIntl();

  useEffect(() => {
    if (listing?.attributes?.publicData?.storeId) {
      onGetShop(listing?.attributes?.publicData?.storeId);
    }
  }, [listing?.attributes?.publicData?.storeId]);

  useEffect(() => {
    if (isProviderRole) {
      onGetBrand(transaction?.customer?.id?.uuid);
    }
  }, []);

  const locationDetails = shop?.attributes?.publicData?.location
    ? shop?.attributes?.publicData?.location?.address
    : intl.formatMessage({ id: 'StripePaymentForm.locationUnknown' });

  if (getHeadingInfoInProgress)
    return (
      <div className={css.spinnerContainer}>
        <IconSpinner />
      </div>
    );

  const listingLink = createListingLink(listing?.attributes?.publicData?.storeId, shop?.attributes?.title || listing?.attributes?.publicData?.storeName, false, {}, '', listing?.attributes?.title)

  const classes = rootClassName || css.root;

  return (
    <div className={classes}>
      <div className={css.headingContainer}>
        <div className={css.titleContainer}>
          <H2 className={css.listingTitleMobile}>
            <FormattedMessage id="TransactionPage.listingTitleMobile" values={{ listingLink }} />
          </H2>
          <div className={css.shopName}>
            {shop?.attributes?.title || listing?.attributes?.publicData?.storeName},{' '}
            <span className={css.location}>{locationDetails}</span>
          </div>
          <div>
            <span className={css.managedBy}>
              {intl.formatMessage({ id: 'TransactionPage.managedBy' })} {transaction?.provider?.attributes?.profile?.displayName?.split(' ')?.[0]}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderPanelHeadingSection;
